"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = void 0;
const handlebars_1 = __importDefault(require("handlebars"));
const polished_1 = require("polished");
const autolinker_1 = __importDefault(require("autolinker"));
exports.helpers = {
    eq: (v1, v2) => v1 === v2,
    gt: (v1, v2) => v1 > v2,
    breaklines: (text) => {
        text = handlebars_1.default.Utils.escapeExpression(text);
        text = text.replace(/(\r\n|\n|\r)/gm, '<br>');
        return new handlebars_1.default.SafeString(text);
    },
    // breaklines + linkify
    content: (text) => {
        text = handlebars_1.default.Utils.escapeExpression(text);
        text = text.replace(/(\r\n|\n|\r)/gm, '<br>');
        text = autolinker_1.default.link(text);
        return new handlebars_1.default.SafeString(text);
    },
    // eslint-disable-next-line
    // @ts-ignore
    rootStyle: (primary, background, custom1, custom2, compPrimaryLight, compPrimaryDark, compBackgroundLight, compBackgroundDark, font) => {
        let white = '#fff';
        let black = '#000';
        let complementPrimary = compPrimaryDark;
        try {
            complementPrimary = polished_1.readableColor(primary, compPrimaryDark || black, compPrimaryLight || white);
        }
        catch (err) { }
        let complementBackground = compBackgroundDark;
        try {
            complementBackground = polished_1.readableColor(background, compBackgroundDark || black, compBackgroundLight || white);
        }
        catch (err) { }
        return new handlebars_1.default.SafeString(`
        <style>
            :root {
                --primary: ${handlebars_1.default.Utils.escapeExpression(primary)};
                --complement-primary: ${handlebars_1.default.Utils.escapeExpression(complementPrimary)};
                --background: ${handlebars_1.default.Utils.escapeExpression(background)};
                --complement-background: ${handlebars_1.default.Utils.escapeExpression(complementBackground)};
                --custom-1: ${handlebars_1.default.Utils.escapeExpression(custom1)};
                --custom-2: ${handlebars_1.default.Utils.escapeExpression(custom2)};
                --font: "${handlebars_1.default.Utils.escapeExpression(font)}";
            }
        </style>
    `);
    },
    singleline: (text) => {
        return text.replace(/(\r\n|\n|\r)/gm, ' ');
    }
};
